export var DEFAULT_KEY = 'default';
export var COLORS_KEY = 'color';
export var PALETTE_KEY = 'palette';
export var BORDER_KEY = 'border';
export var MEDIA_KEY = 'media';
export var SIZES_KEY = 'size';
export var SPACE_KEY = 'space';
export var RADIUS_KEY = 'radius';
export var TEXT_STYLE_KEY = 'textStyle';
export var BOX_STYLE_KEY = 'boxStyle';
export var FONT_KEY = 'fontFamily';
export var DEFAULT_MEDIA_KEY = 'all';